/*distant config*/

export const url_liste_objets = 'https://architecture-precarites.fr/precarites_urbaines/fiches/';
export const url_annexes = 'https://architecture-precarites.fr/precarites_urbaines/annexes/';
export const url_actualites = 'https://architecture-precarites.fr/precarites_urbaines/actualites/';
export const url_files = 'https://architecture-precarites.fr/';

/*local config*/

/*localhost : local*/
/*export const url_liste_objets = 'http://localhost/precarites_urbaines/fiches/';
export const url_annexes = 'http://localhost/precarites_urbaines/annexes/';
export const url_actualites = 'http://localhost/precarites_urbaines/actualites/';
export const url_files = 'http://localhost';*/

/*localhost (jdb) : ip*/
/*export const url_liste_objets = 'http://192.168.1.169/precarites_urbaines/fiches/';
export const url_annexes = 'http://192.168.1.169/precarites_urbaines/annexes/';
export const url_actualites = 'http://192.168.1.169/precarites_urbaines/actualites/';
export const url_files = 'http://192.168.1.169';*/

/*do not touch*/
export const url_base = "/";
export const url_excel = url_annexes+"excel";